export const filterPrices = [
    {
        start : 100,
        end : 1000
    },
    {
        start : 1000,
        end : 2000
    },
    {
        start : 2000,
        end : 3000
    },
    {
        start : 3000,
        end : 4000
    },
    {
        start : 4000,
        end : 5000
    },
    {
        start : 5000,
        end : 6000
    }
]